import React, { useState, useEffect } from 'react';
import Manzana from './Manzana';
import FormularioLote from './FormularioLote';
import logo from './logo.png'
import plano from './plano.jpg'
import whats from './whatsapplogo.png';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Container, Box, Typography, CssBaseline, Grid } from '@mui/material';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';


const tusCoordenadas = '-39.110801, -66.966885';

const phoneNumber = '5492984144403'; // Número en formato internacional
const phoneNumberFormated = '54 9 2984 144403'; // Número en formato internacional

const message = 'Hola, me gustaría obtener más información.'; // Mensaje inicial
let urlEncodedText = encodeURIComponent(message);


// Lee el parámetro desde el `data-*` del HTML
const rootElement = document.getElementById('root');
const mensajeInicial = rootElement ? rootElement.getAttribute('data-mensaje-inicial') : '';


const theme = createTheme({
  palette: {
    background: {
      default: '#red',
    },
    overrides: {
      MuiContainer: {
        root: {
          borderRadius: 5,
        },
      },
    },
  },
});

const iconStyle = {
  width: "100px",
  marginRight: "1px",
  cursor: "pointer",
  height: '20%', // ajusta según sea necesario
  marginLeft: '0px',
  color:"black",
  filter: "invert(100%)",
};

const iconStyleW = {
  width: "30px",
  marginRight: "1px",
  cursor: "pointer",
  height: '20%', // ajusta según sea necesario
  marginLeft: '0px',
};


// Componente Modal con cierre al hacer clic en la imagen
const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose(); // Cierra el modal si el clic es en el fondo
        }
      }} // Manejador de clic para el fondo del modal
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 1,
          backgroundColor: '#DDDDDD',
          maxWidth: '90vw',
          maxHeight: '90vh',
          overflow: 'hidden',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.25)',
          p: 2,
        }}
        onClick={(e) => e.stopPropagation()} // Evita que el clic en el contenido se propague al fondo
      >
        {React.cloneElement(children, {
          onClick: onClose, // Cierra el modal al hacer clic en la imagen
          style: {
            width: '100%',
            height: 'auto',
            display: 'block',
            objectFit: 'contain',
            maxHeight: '80vh',
            margin: '0 auto',
            backgroundColor: 'red',
          },
        })}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2,
            backgroundColor: '#eee',
          }}
        >
          <Button onClick={onClose}>Cerrar</Button>
        </Box>
      </Box>
    </Box>
  );
};



const App = () => {
  const [manzanas, setManzanas] = useState([]);
  const [loteSeleccionado, setLoteSeleccionado] = useState(null);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalManzanaOpen, setIsModalManzanaOpen] = useState(false);
  const [imagenModalManzana, setImagenModalManzana] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [locationDetails, setLocationDetails] = useState(null);
  const [moneda, setMoneda] = useState(3);
  const [currencySymbol, setCurrencySymbol] = useState('');


  // Encode el mensaje para usar en el enlace de WhatsApp
  urlEncodedText = encodeURIComponent(mensajeInicial);

  const gridConfig = {
    container: true,
    justifyContent: "space-between",
    sx: {
      width: '100%', 
      mt: 2, 
      mb: 2, 
      backgroundColor: '#cccccc', 
      boxShadow: '0px 4px 3px rgba(0, 0, 0, 0.5)'
    }
  }  

  const gridConfigManzanas = {
    container: true,
    justifyContent: "space-between",
    sx: {
      width: '100%', 
      mt: 2, 
      mb: 2, 
      backgroundColor: 'transparent', 
    }
  }  
  
  const abrirModal = () => {
    setIsModalOpen(true);
  };


  const obtenerUrlImagenManzana = (idManzana) => {
    // Asumiendo que el idManzana siempre está en formato numérico y que las imágenes están en el directorio 'src/manzanas/'
    const idConCeros = idManzana.toString().padStart(2, '0'); // Esto convierte 1 en '01', 16 en '16', etc.
    return require(`./manzanas/M${idConCeros}.jpg`);
  };

  const abrirModalManzana = (idManzana) => {
    const urlImagenManzana = obtenerUrlImagenManzana(idManzana);
    setImagenModalManzana(urlImagenManzana);
    setIsModalManzanaOpen(true);
  };

  useEffect(() => {
    // Obtener la IP del usuario
    /*const fetchUserIP = async () => {
      const res = await fetch('https://api.ipify.org?format=json');
      const data = await res.json();
      const userIP = data.ip;
      
      // Solicitar información de geolocalización desde tu servidor
      const ipInfoRes = await fetch(`https://propietarios.pueblonuevo.com.ar/backendvalle/get-ip-info?ip=${userIP}`);
      const ipInfoData = await ipInfoRes.json();
      setLocationDetails(ipInfoData);
      (ipInfoData.country === 'AR' ? setMoneda(3): setMoneda(2))
    };

    fetchUserIP();*/
    setMoneda(3);
  }, []);

  useEffect(() => {
    // Verifica si 'moneda' tiene un valor válido antes de hacer el fetch
    if (moneda != null) {
      fetch(`https://propietarios.pueblonuevo.com.ar/backendvalle/lotestotales?moneda=${moneda}`)
        .then(response => {
          if (!response.ok) {           
            throw new Error('Error al cargar los datos');
          }
          return response.json();
        })
        .then(data => {
          const manzanasAgrupadas = agruparPorManzana(data);
          setManzanas(manzanasAgrupadas);
          setCargando(false); 
        })
        .catch(error => {
          setError(error.message);
          setCargando(false);
        });
    } else {
      // Aquí puedes manejar el caso cuando 'moneda' no está definido, por ejemplo, mostrando un mensaje
      console.log("Moneda no está definida, no se realiza el fetch.");
    }
  }, [loteSeleccionado, moneda]);


  useEffect(() => {
    if (moneda != null) {
      const symbol = moneda === 2 ? 'U$S' : '$';
      setCurrencySymbol(symbol);
    }
  }, [moneda]);

  const agruparPorManzana = (lotes) => {
    const agrupacion = {};
    lotes.forEach(lote => {
      if (!agrupacion[lote.Manzana]) {
        agrupacion[lote.Manzana] = { idManzana: lote.Manzana, lotes: [] };
      }
      agrupacion[lote.Manzana].lotes.push(lote);
    });
    return Object.values(agrupacion);
  };
  
  const cancelarSeleccion = () => {
    setLoteSeleccionado(null);
  };

  const seleccionarLote = (lote) => {
    setLoteSeleccionado(lote);
  };

  if (loteSeleccionado) {
    return <FormularioLote lote={loteSeleccionado} moneda={moneda} currencySymbol={currencySymbol} onCancelar={cancelarSeleccion} obtenerUrlImagenManzana={obtenerUrlImagenManzana} />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> 
      <Container maxWidth="xl" sx={{
        display: 'flex', 
        flexDirection: 'column',
        minHeight: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
      }}>
        {/* Cabezera con logo y título */}
        <Box sx={{
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          p: 2, 
          width:'100%',
          borderRadius: '15px',
          boxShadow: '-4px 4px 10px rgba(0, 0, 0, 0.1)'
        }}>
          {( <img src={logo} alt="Carrito" style={{
                ...iconStyle,
                filter: "invert(100%)",
              }}/>)}
          <Box>
          <Typography variant="h4" component="h1">
            Loteo Valle Manzano 
          </Typography>
          <div>
              <a href={`https://wa.me/${phoneNumber}?text=${urlEncodedText}`} target="_blank" rel="noopener noreferrer">
                  Contacta con nosotros vía WhatsApp:  &nbsp; 
                  {( <img src={whats} alt="logo" style={{
                    ...iconStyleW,
                  }}/>)}
              </a>
              <br/>Cel: {phoneNumberFormated}
          </div>
          </Box>
        </Box>
        
        {/* Mapa y plano en su propia fila */}
        <Grid {...gridConfig}>
          <Grid item xs={12} md={6}>
            <Box sx={{ p: 2, cursor: 'zoom-in', display: 'flex', justifyContent: 'space-between' }}>
              <img
                src={plano}
                alt="Plano Loteo Valle Manzano"
                style={{
                  width: '100%', // Asegúrate de que esto esté en porcentaje para que sea responsivo
                  maxWidth: '600px', // Tamaño máximo igual para ambos
                  height: '500px', // Altura fija igual para ambos
                  objectFit: 'contain', // Mantiene la proporción del contenido
                  boxShadow: '0px 4px 3px rgba(0, 0, 0, 0.5)',
                  backgroundColor: '#FFFFFF',
                }}
                onClick={abrirModal}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ p: 2, cursor: 'zoom-in', display: 'flex', justifyContent: 'flex-end' }}>
              <iframe
                title='Mapa'
                src={`https://maps.google.com/maps?q=${tusCoordenadas}&hl=es&z=14&output=embed&t=k`}
                style={{
                  border: '0',
                  width: '100%', // Asegúrate de que esto esté en porcentaje para que sea responsivo
                  maxWidth: '600px', // Tamaño máximo igual para ambos
                  height: '500px', // Altura fija igual para ambos
                  boxShadow: '0px 4px 3px rgba(0, 0, 0, 0.5)',
                  backgroundColor: '#DDDDDD',
                }}
                allowFullScreen=""
                loading="lazy"
              />
            </Box>
          </Grid>
        </Grid>
        { cargando &&
            (
              <Box display="flex" flexDirection= 'column' justifyContent="center" alignItems="center" minHeight="100vh">
                <Typography variant="h4" component="h1">
                    
                  </Typography>
                <CircularProgress />
                <Typography >
                    Cargando información de lotes ...
                  </Typography>
              </Box>
            )
          }
        {/* Manzanas debajo del mapa */}
        {!cargando && (<Grid {...gridConfigManzanas}>
          {manzanas.map((manzana, index) => (
            <>
            <Manzana key={index} idManzana={manzana.idManzana} lotes={manzana.lotes} currencySymbol={currencySymbol} onSeleccionarLote={seleccionarLote} onAbrirModalManzana={abrirModalManzana} obtenerUrlImagenManzana={obtenerUrlImagenManzana}/>
            <Modal isOpen={isModalManzanaOpen} onClose={() => setIsModalManzanaOpen(false)}>
                {imagenModalManzana && (
                  <img src={imagenModalManzana} alt={`Plano de la manzana ${imagenModalManzana}`} />
                )}
              </Modal>
              </>
          ))}
        </Grid>)}
        {/* Modal para el mapa ampliado */}
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <Box sx={{ outline: 'none' }}>
              <img src={plano} alt="Plano Ampliado" style={{ width: '100vh', height: '80vh' }} />
            </Box>
        </Modal>
      </Container>
    </ThemeProvider>
  );
};

export default App;
